<template>
  <div class="import-reports-view">
    <h1>Warteschlange</h1>
    <span>{{queuedJobs.running}} laufen, {{queuedJobs.pending}} warten</span>
        <data-grid
      :columns="gridColumns"
      :editable="false"
      :is-loading="isLoading"
      :page-info="{}"
      :removable="false"
      :rows="queuedJobs.entries"
      class="uk-margin-medium"
      v-if="gridLoaded"
    >
      <template scope="statusProps" slot="status">
         <span v-if="statusProps.value">
           {{statusProps.value}}
         </span>
        <text-placeholder v-else />
      </template>
      <template scope="createdAtProps" slot="createdAt">
         <span v-if="createdAtProps.value">
           {{createdAtProps.value | niceTime}}
         </span>
        <text-placeholder v-else />
      </template>
      <template scope="functionProps" slot="function">
           <span v-if="functionProps.value">
           {{functionProps.value}}
         </span>
        <text-placeholder v-else />
      </template>
    </data-grid>
  </div>
</template>

<script>
import queuedJobsQuery from '@/api/queries/queued-jobs.graphql';
import IndexView from '@/mixins/IndexView';

export default {
  name: 'queued-jobs-view',
  mixins: [
    IndexView('queuedJobs', {
      gridFields: ['status', 'createdAt', 'function'],
      listQuery: queuedJobsQuery,
      nameField: 'name',
      pollInterval: 5000,
    }),
  ],
  computed: {
    breadcrumbs() {
      return [
        {
          key: 'queuedJobs',
          route: { name: 'queued-jobs' },
        },
      ];
    },
  },
  i18n: {
    messages: {
      de: {
        breadcrumbs: {
          queuedJobs: 'Warteschlange',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// QueuedJobs.vue?86fe74c4